import { defaultBaseQuery, transformErrorResponse, transformSuccessResponse } from "@/services";
import { createApi } from "@reduxjs/toolkit/query/react";

const studentDashboardAPI = createApi({
    reducerPath: "studentDashboardAPI",
    baseQuery: defaultBaseQuery,
    tagTypes: ["PunchSummary", "MonthlySummary", "AttendanceTrend", "MonthlyPunchAverage", "AttendanceCalendar"],
    endpoints: (builder) => ({
        // GET /s-lams/dashboard/student/punch-summary
        getTodayPunchSummary: builder.query({
            query: () => ({
                url: `/dashboard/student/punch-summary`,
                method: "GET",
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
            providesTags: ["PunchSummary"],
        }),
        // GET /s-lams/dashboard/student/monthly-summary?month=YYYY-MM
        getMonthlySummary: builder.query({
            query: (month) => ({
                url: `/dashboard/student/monthly-summary`,
                method: "GET",
                params: { month },
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
            providesTags: ["MonthlySummary"],
        }),
        // GET /s-lams/dashboard/student/attendance-trend?fromMonth=YYYY-MM&toMonth=YYYY-MM
        getAttendanceTrend: builder.query({
            query: ({ fromMonth, toMonth }) => ({
                url: `/dashboard/student/attendance-trend`,
                method: "GET",
                params: { fromMonth, toMonth },
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
            providesTags: ["AttendanceTrend"],
        }),
        // GET /s-lams/dashboard/student/monthly-punch-average?month=YYYY-MM
        getMonthlyPunchAverage: builder.query({
            query: (month) => ({
                url: `/dashboard/student/monthly-punch-average`,
                method: "GET",
                params: { month },
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
            providesTags: ["MonthlyPunchAverage"],
        }),
        // GET /s-lams/dashboard/student/calendar?month=YYYY-MM
        getAttendanceCalendar: builder.query({
            query: (month) => ({
                url: `/dashboard/student/calendar`,
                method: "GET",
                params: { month },
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
            providesTags: ["AttendanceCalendar"],
        }),
    }),
});

export const {
    useGetTodayPunchSummaryQuery,
    useGetMonthlySummaryQuery,
    useGetAttendanceTrendQuery,
    useGetMonthlyPunchAverageQuery,
    useGetAttendanceCalendarQuery,
} = studentDashboardAPI;

export default studentDashboardAPI;
